import { RouteComponentProps } from "@reach/router"
import { Card } from "@shared/primitive-components"
import { ScreenContentWithContext } from "../../components/ScreenContentWithContext"
import { AddToFleetContent } from "./AddToFleetContent"

export const ADD_TO_FLEET_PAGE_DTI = `fleet_add_root`

export const AddToFleet: React.FC<RouteComponentProps> = () => (
  <ScreenContentWithContext title="Add vehicles" dataTestIds={{ root: ADD_TO_FLEET_PAGE_DTI }}>
    <Card>
      <AddToFleetContent />
    </Card>
  </ScreenContentWithContext>
)
